<mat-radio-group [formControl]="law_firm_missing">
  <mat-radio-button [value]="1">Ügyvéd hiányzik</mat-radio-button>
  <mat-radio-button [value]="0">Ügyvéd van</mat-radio-button>
</mat-radio-group>
